import ReactGA from "react-ga";

export const logPageView = () => {
  const { pathname, search } = window.location;
  const page = pathname + search;

  ReactGA.set({ page });
  ReactGA.pageview(page);
};
